"use client";

import Cookies from "js-cookie";
import { LuSparkles } from "react-icons/lu";
import { useLocalStorage } from "usehooks-ts";

import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { toast } from "@/components/ui/use-toast";
import { useIsClient } from "@/hooks/use-is-client";
import { CookieKeys } from "@/utils/cookie-keys";
import { LocalStorageKeys } from "@/utils/local-storage-keys";

export const Ducky = () => {
  const isClient = useIsClient();
  const [feedFreezeDebug, setFeedFreezeDebug] = useLocalStorage(
    LocalStorageKeys.feedFreezeDebug,
    "",
  );

  if (!isClient) {
    return null;
  }

  return (
    <div className="fixed right-4 bottom-24 z-10000 w-[calc(100vw-2rem)] max-w-max">
      <Card className="p-4">
        <Tabs defaultValue="notifications">
          <TabsList className="mb-4 max-w-full overflow-x-auto">
            <TabsTrigger value="notifications">Notifications</TabsTrigger>
            <TabsTrigger value="toasts">Toasts</TabsTrigger>
            <TabsTrigger value="flags">Flags</TabsTrigger>
            <TabsTrigger value="user">User</TabsTrigger>
          </TabsList>
          <TabsContent value="notifications">
            <Button
              onClick={() => {
                navigator.serviceWorker.ready.then(function (registration) {
                  // @ts-expect-error we dont care
                  registration.active.postMessage({
                    type: "trigger-notification",
                    payload: {
                      title: "This is the title",
                      options: {
                        icon: "https://test.deso.org/api/v0/get-single-profile-picture/tBCKXxuFpPvwRb4Nsat1BoiBSRxA115uYqPN9ZqYzThsYqrgUt8Vfb?fallback=https://beta.focus.xyz/generated/notification-action-icons/REACTION_LOVE-light.png",
                        badge: "/logo-focus-whale-outline-white-96x96.png",
                        tag: Math.random().toString(36).substring(7),
                        body: "This is the body",
                        actions: [
                          {
                            action:
                              "/post/d375bb1a4a7be9f1276973c8793ab979820d01e6c5cba4da8a86fe4fc03835b3",
                            title: "View Post",
                            icon: "/generated/notification-action-icons/ActionViewPost-light.png",
                          },
                          {
                            action: "/DillanThomas",
                            title: "View Profile",
                            icon: "/generated/notification-action-icons/ActionViewProfile-light.png",
                          },
                        ],
                      },
                    },
                  });
                });
              }}
            >
              Trigger sample notification
            </Button>
          </TabsContent>
          <TabsContent value="toasts">
            <div className="grid grid-cols-2 gap-2">
              <Button
                variant="outline"
                onClick={() => {
                  toast({
                    title: "Neutral toast",
                    description: "Plain toast without a status icon.",
                  });
                }}
              >
                Neutral
              </Button>
              <Button
                variant="outline"
                onClick={() => {
                  toast({
                    title: "Success toast",
                    description: "Uses the default circle check icon.",
                    variant: "success",
                  });
                }}
              >
                Success
              </Button>
              <Button
                variant="outline"
                onClick={() => {
                  toast({
                    title: "Notification toast",
                    description: "Notification styling, no default icon.",
                    variant: "notification",
                  });
                }}
              >
                Notification
              </Button>
              <Button
                variant="outline"
                onClick={() => {
                  toast({
                    title: "Warning toast",
                    description: "Warning styling, no default icon.",
                    variant: "warning",
                  });
                }}
              >
                Warning
              </Button>
              <Button
                variant="outline"
                onClick={() => {
                  toast({
                    title: "Error toast",
                    description: "Uses the default triangle alert icon.",
                    details:
                      "Ducky generated error details for testing the expander.",
                    variant: "destructive",
                  });
                }}
              >
                Error
              </Button>
              <Button
                variant="outline"
                onClick={() => {
                  toast({
                    title: "Custom icon",
                    description: "This toast passes a custom React element.",
                    icon: <LuSparkles className="text-yellow-200" />,
                    variant: "success",
                  });
                }}
              >
                Custom Icon
              </Button>
            </div>
          </TabsContent>
          <TabsContent value="flags">
            <div className="flex items-center space-x-2">
              <Switch
                id="feed_freeze_debug"
                checked={feedFreezeDebug === "1"}
                onCheckedChange={(checked) => {
                  setFeedFreezeDebug(checked ? "1" : "");
                }}
              />
              <Label htmlFor="feed_freeze_debug">
                Enable Feed Freeze Debug
              </Label>
            </div>
          </TabsContent>
          <TabsContent value="user">
            <div className="flex flex-col items-center gap-2">
              <form
                method="post"
                onSubmit={(e) => {
                  e.preventDefault();
                  const data = new FormData(e.currentTarget);
                  Cookies.set(
                    CookieKeys.publicKey,
                    data.get("publicKey") as string,
                  );
                  localStorage.setItem(
                    "desoActivePublicKey",
                    data.get("publicKey") as string,
                  );
                  window.location.reload();
                }}
              >
                Use site as publicKey:
                <input
                  type="text"
                  name="publicKey"
                  className="border border-border"
                />
                <Button type="submit">Go</Button>
              </form>

              <div>
                <Button
                  onClick={() => {
                    Cookies.remove(CookieKeys.publicKey);
                    localStorage.removeItem("desoActivePublicKey");
                    window.location.reload();
                  }}
                >
                  Force logout
                </Button>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </Card>
    </div>
  );
};
